import { publicCommonClient } from '../../../interfaces/clients';

const getWidget = async (widgetId) => publicCommonClient.get(`/api/widgets/${widgetId}`);

export default {
  getWidget,
};
